import { MESSAGES } from '@/constants/messages';
import { ROUTES } from '@/constants/routes';
import { useDeleteExternalAccount } from '@/hooks/requests/useExternalAccounts';
import { ExternalAccountActionButtonProps } from '@/types/externalAccounts';
import showToast from '@/utils/toast';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  DialogActions,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { SVButton } from '@/components/core';

export default function ExternalAccountDeleteButton({
  id,
  ownerId,
}: ExternalAccountActionButtonProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { deleteExternalAccount, isDeleteExternalAccountPending } =
    useDeleteExternalAccount();

  async function handleConfirm() {
    try {
      await deleteExternalAccount(id);
      showToast({
        type: 'success',
        data: { content: 'The external account has been deleted' },
      });
      navigate(`${ROUTES.CUSTOMERS}/${ownerId}/external-accounts`);
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <>
      <SVButton fullWidth variant="error" onClick={() => setOpen(true)}>
        Delete
      </SVButton>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <DialogContent>
          <Box>
            <Typography variant="h6" component="h2">
              Delete External Account
            </Typography>
            <Typography sx={{ mt: 2 }}>
              Are you sure you want to delete this linked account? Deleting is
              permanent and if the customer would like to use this account in
              the future, they will need to submit a new form.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <SVButton onClick={() => setOpen(false)} variant="tertiary">
            No, Don't Delete
          </SVButton>
          <SVButton
            onClick={handleConfirm}
            variant="error"
            isLoading={isDeleteExternalAccountPending}>
            Yes, Delete
          </SVButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
